import { Component, EventEmitter, Input, Output } from '@angular/core';

import { Offer, OfferStatus } from 'src/app/shared/constants/offer';
import { AccountService } from 'src/app/shared/services/account.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { IndicatorService } from 'src/app/shared/services/indicator.service';

@Component({
  selector: 'app-send-notification-btn',
  templateUrl: './send-notification-btn.component.html',
  styleUrls: ['./send-notification-btn.component.scss'],
})
export class SendNotificationBtnComponent {
  @Input() selections: any[] | undefined;
  @Input() notificationText!: string;
  @Input() offer!: Offer;
  @Input() notificationType!: string;

  @Output() notificationSent = new EventEmitter<void>();

  readonly OfferStatus = OfferStatus;

  constructor(
    private dialogService: DialogService,
    private indicatorService: IndicatorService,
    private accountService: AccountService,
  ) { }

  async sendNotification() {

    const confirmationMessage = this.selections
    ? `The active AdSpaces will be notified about the selected ${this.notificationText}. Are you sure?`
    : `The active AdSpaces will be notified about the new ${this.notificationText}. Are you sure?`;

    const ok = await this.dialogService.askConfirmation(confirmationMessage);

    if (!ok) {
      return false;
    }

    try {
      this.accountService.sendAdNotification(this.notificationType, this.selections, this.offer.id);
    } catch {
      this.indicatorService.failureIndicator();
      return;
    }

    this.indicatorService.success(null, 'Notification sent successfully!');
    this.notificationSent.emit();
  }

}
